



































import { deleteImages } from "@/api/delite/delite-element";
import { pics } from "@/config/host.config";
import { Component, Vue } from "vue-property-decorator";

import UploadingImageToServer from "@/components/app/images/uploading-image-to-server.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: { StandartModal, upload: UploadingImageToServer },
})
export default class RouteSvgIconsModal extends Vue {
  iconfolder = "main/configuration/icons";
  navicons: Array<string> = [];

  async getNavIcons(): Promise<void> {
    const params = { path: this.iconfolder };
    try {
      const resicon = await this.$axios.get(pics.download, { params });
      if (resicon.status === 200) {
        this.navicons =
          resicon.data == "Папка не найдена" || resicon.data == "Папка пуста"
            ? []
            : resicon.data;
      }
    } catch (error) {
      console.error(error);
    }
  }

  async deletedIcon(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("confirm.delete.icon")),
        }
      );

      if (result === true) {
        deleteImages(id, this.iconfolder);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  mounted(): void {
    this.getNavIcons();
  }
}
